import React, {useEffect, useState} from 'react';
import axios from 'axios';
import styled from 'styled-components';
import $ from "jquery";
import brclogo from '../../assets/brc_logo.svg';
import htblogo from '../../assets/htb_logo.png';

const TopLogo = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 360;
  width: 122px;
  display: none;

  @media (min-width: 600px) and (min-height: 500px) {
    display: inline-block;
  }
  @media (min-width: 1280px) {
    top: 20px;
    left: 20px;
    width: 132px;
  }
  img {
    width: 100%;
  }
`;
const OverlayLogo = styled.div`
  position: relative;
  width: 110px;
  display: inline-block;

  img {
    width: 100%;
  }
`;
const BottomLogo = styled.div`

`;
const Logo = (props) => {
  const [loading, setLoading] = useState(false);
  const [partnerLogo, setParterLogo] = useState(null);

  const handlePartnerLogoClick = () => {
    try {
      const url = process.env.REACT_APP_BRC_API_URL + "/v2/partner-logo";
      $.post(url, {
        partnerLogoId: partnerLogo.id,
      }, 'json');
      props.handleOnClick();
    } catch (_error) {}
  }

  const getPartnerLogo = async () => {
    try {
      setLoading(true);
      const response = await axios("/v2/partner-logo");
      setParterLogo(response.data)
    } catch (e) {

    }
    setLoading(false);
  };

  useEffect(() => {
    getPartnerLogo();
  }, []);

  switch (props.logo) {
    case 'brc':
      return loading ? null : (
        <TopLogo onClick={(partnerLogo && partnerLogo.absoluteUrl) ? handlePartnerLogoClick : props.handleOnClick}><img src={(partnerLogo && partnerLogo.absoluteUrl) || brclogo} alt="Beach Report Card" /></TopLogo>
      );
    case 'brc2':
      return loading ? null : (
        <OverlayLogo onClick={(partnerLogo && partnerLogo.absoluteUrl) ? handlePartnerLogoClick : props.handleOnClick}><img src={(partnerLogo && partnerLogo.absoluteUrl) || brclogo} alt="Beach Report Card" /></OverlayLogo>
      );
    case 'htb':
      return (
        <BottomLogo><img src={htblogo} alt="Heal the Bay" /></BottomLogo>
    );
    default:
      return '';
  }

}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/graphics/Logo.js